import React from 'react'
import BlogImg from "../assets/img/blog/01.jpg"
import BlogImg1 from "../assets/img/blog/02.jpg"
import BlogImg2 from "../assets/img/blog/03.jpg"

function BlogArea() {
  return (
    <div className="blog-area py-120">
        <div className="container">
            
            <div className="row">
                <div className="col-lg-6 mx-auto">
                    <div className="site-heading text-center">
                        <span className="site-title-tagline"><i className="flaticon-drive"></i> Stay Updated</span>
                        <h2 className="site-title">Latest Updates & Insights</h2>
                        <div className="heading-divider"></div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-4">
                    <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                        <div className="blog-item-img">
                            <img src={BlogImg} alt="ServiSwift Launches TaxiDo" />
                        </div>
                        <div className="blog-item-info">
                            <div className="blog-item-meta">
                                <ul>
                                    <li><a href="blog/taxido-launch"><i className="far fa-user-circle"></i> By ServiSwift Team</a></li>
                                    <li><a href="blog/taxido-launch"><i className="far fa-calendar-alt"></i> January 10, 2025</a></li>
                                </ul>
                            </div>
                            <h4 className="blog-title">
                                <a href="blog/taxido-launch">ServiSwift Launches TaxiDo: Revolutionizing Ride-Hailing in Malawi</a>
                            </h4>
                            <a className="theme-btn" href="blog/taxido-launch">Read More<i className="fas fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
                
                <div className="col-md-6 col-lg-4">
                    <div className="blog-item wow fadeInUp" data-wow-delay=".50s">
                        <div className="blog-item-img">
                            <img src={BlogImg1} alt="HandyMan: Your Reliable Partner" />
                        </div>
                        <div className="blog-item-info">
                            <div className="blog-item-meta">
                                <ul>
                                    <li><a href="blog/handyman-services"><i className="far fa-user-circle"></i> By ServiSwift Team</a></li>
                                    <li><a href="blog/handyman-services"><i className="far fa-calendar-alt"></i> January 5, 2025</a></li>
                                </ul>
                            </div>
                            <h4 className="blog-title">
                                <a href="blog/handyman-services">HandyMan: Your Go-To Solution for Maintenance & Repairs</a>
                            </h4>
                            <a className="theme-btn" href="blog/handyman-services">Read More<i className="fas fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
                
                <div className="col-md-6 col-lg-4">
                    <div className="blog-item wow fadeInUp" data-wow-delay=".75s">
                        <div className="blog-item-img">
                            <img src={BlogImg2} alt="SwiftDelivery Expands" />
                        </div>
                        <div className="blog-item-info">
                            <div className="blog-item-meta">
                                <ul>
                                    <li><a href="blog/swiftdelivery-expansion"><i className="far fa-user-circle"></i> By ServiSwift Team</a></li>
                                    <li><a href="blog/swiftdelivery-expansion"><i className="far fa-calendar-alt"></i> December 20, 2024</a></li>
                                </ul>
                            </div>
                            <h4 className="blog-title">
                                <a href="blog/swiftdelivery-expansion">SwiftDelivery Expands to Serve More Districts in Malawi</a>
                            </h4>
                            <a className="theme-btn" href="blog/swiftdelivery-expansion">Read More<i className="fas fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BlogArea